import React from 'react';
import { UserIcon, BookIcon, TagIcon, UsersIcon, HeadphonesIcon, ShoppingBagIcon, CalendarIcon, BookOpenIcon, HeartIcon, ClipboardListIcon, SettingsIcon, HelpCircleIcon, LayoutDashboardIcon, LineChartIcon, TruckIcon, StarIcon, FileTextIcon, PercentIcon, PenToolIcon, CameraIcon, PencilIcon, ImageIcon, MailIcon, PaletteIcon, BrushIcon, PackageIcon, DollarSignIcon, MegaphoneIcon, HandshakeIcon, BuildingIcon, StoreIcon, BookmarkIcon, SearchIcon, TrophyIcon, HeartHandshakeIcon, AlertCircleIcon, FlameIcon, MapPinIcon, BellIcon, LayoutGridIcon, ZapIcon, LinkIcon, GlobeIcon, LibraryIcon, CompassIcon, SparklesIcon, LayersIcon, MessageSquareIcon } from 'lucide-react';
import { MenuSection } from './types';
export const vendorMenuSections: MenuSection[] = [{
  id: 'dashboard',
  label: 'Dashboard',
  icon: <LayoutDashboardIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2517" data-mp="2qgchcbw9is19" />,
  to: '/vendors/dashboard'
}, {
  id: 'discover',
  label: 'Discover',
  icon: <CompassIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2518" data-mp="3bndf7z1krpjd" />,
  children: [{
    label: 'Story Galaxy',
    to: '/story-galaxy',
    icon: <SparklesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2519" data-mp="31slfopofmsly" />
  }, {
    label: 'Story Stack',
    to: '/story-stack',
    icon: <LayersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2520" data-mp="2xsbavgcdm88o" />
  }, {
    label: 'Book Discovery',
    to: '/discover',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2521" data-mp="3pguxzhmfsy8c" />
  }]
}, {
  id: 'manage',
  label: 'Manage Products',
  icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2522" data-mp="3koldih43cqdg" />,
  children: [{
    label: 'Add New Listing',
    to: '/vendors/product-manager',
    icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2523" data-mp="h1l3aukvmval" />
  }, {
    label: 'Manage Listings',
    to: '/manage-listings',
    icon: <ClipboardListIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2524" data-mp="c8i70eopt7qp" />
  }, {
    label: 'Orders & Shipping',
    to: '/orders',
    icon: <TruckIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2525" data-mp="2bgi1gvc0oi6e" />
  }, {
    label: 'Pre-Orders',
    to: '/vendors/preorders',
    icon: <PackageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2526" data-mp="1wqkhysp18gnj" />
  }, {
    label: 'ARC Management',
    to: '/vendors/arc',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2527" data-mp="1nrpbrglzn6k8" />
  }, {
    label: 'Book Graphics',
    to: '/books/graphics',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2528" data-mp="1soz16w9dni82" />
  }]
}, {
  id: 'catalogs',
  label: 'My Catalogs',
  icon: <LibraryIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2529" data-mp="1iscgc7h1wr61" />,
  children: [{
    label: 'Virtual Bookshelf',
    to: '/authors/bookshelf',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2530" data-mp="385pne4gjstau" />
  }, {
    label: 'Narrator Portfolio',
    to: '/narrator/shelf',
    icon: <HeadphonesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2531" data-mp="11klb8bf4hbk7" />
  }, {
    label: 'Box Catalog',
    to: '/bookbox/shelf',
    icon: <PackageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2532" data-mp="wim6ax3qi6l5" />
  }, {
    label: 'Merch Catalog',
    to: '/merch/shelf',
    icon: <ShoppingBagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2533" data-mp="16icz8ucncdj4" />
  }, {
    label: 'My Catalog',
    to: '/vendor/shelf',
    icon: <LayoutGridIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2534" data-mp="1kc4cacpl6fjl" />
  }]
}, {
  id: 'content',
  label: 'Content',
  icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2535" data-mp="1u8qwcza392kk" />,
  children: [{
    label: 'All Content Tags',
    to: '/all-content-tags',
    icon: <LayoutGridIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2536" data-mp="1p71ht9nnq6rq" />
  }, {
    label: 'Tropes',
    to: '/tropes',
    icon: <HeartHandshakeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2537" data-mp="3r10sptwvam3w" />
  }, {
    label: 'Characters',
    to: '/characters',
    icon: <UserIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2538" data-mp="3shengu8h67bl" />
  }, {
    label: 'Relationship Types',
    to: '/relationship-types',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2539" data-mp="69wrq38llr9c" />
  }, {
    label: 'Pairing Types',
    to: '/pairing-types',
    icon: <LinkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2540" data-mp="b8rmm3jub69t" />
  }, {
    label: 'Spice & Darkness',
    to: '/spice-darkness',
    icon: <FlameIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2541" data-mp="3epqcwvdvjqwq" />
  }, {
    label: 'Burn Levels',
    to: '/burn-levels',
    icon: <ZapIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2542" data-mp="3jnrqx1wg101c" />
  }, {
    label: 'Ending Types',
    to: '/ending-types',
    icon: <BookmarkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2543" data-mp="2r0xbijehgquq" />
  }, {
    label: 'Representation',
    to: '/representation',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2544" data-mp="2vy78ql8466t4" />
  }, {
    label: 'Cultural Identity',
    to: '/cultural-identity',
    icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2545" data-mp="193bwcckph8rf" />
  }, {
    label: 'Themes',
    to: '/themes',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2546" data-mp="142o4joonknw5" />
  }, {
    label: 'Book Settings',
    to: '/settings',
    icon: <MapPinIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2547" data-mp="z78qavmqgpz7" />
  }, {
    label: 'Content Warnings',
    to: '/content-warnings',
    icon: <AlertCircleIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2548" data-mp="pe9rkkxivj1v" />
  }]
}, {
  id: 'analytics',
  label: 'Analytics',
  icon: <LineChartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2549" data-mp="lb3ofm5pi7zm" />,
  children: [{
    label: 'Sales Reports',
    to: '/analytics',
    icon: <LineChartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2550" data-mp="be8snb0tilp1" />
  }, {
    label: 'Royalties',
    to: '/vendors/royalties',
    icon: <DollarSignIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2551" data-mp="6ijp6wlogkng" />
  }, {
    label: 'Reader Insights',
    to: '/vendors/insights',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2552" data-mp="1shaxknnz0jm" />
  }, {
    label: 'Reviews',
    to: '/vendors/reviews',
    icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2553" data-mp="3jznkgufj588a" />
  }]
}, {
  id: 'marketing',
  label: 'Marketing',
  icon: <MegaphoneIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2554" data-mp="fikta0jfaa3s" />,
  children: [{
    label: 'Marketing Hub',
    to: '/vendors/marketing',
    icon: <LayoutDashboardIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2555" data-mp="kk0bzly4o4j0" />
  }, {
    label: 'Promotions & Discounts',
    to: '/vendors/marketing/promotions',
    icon: <PercentIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2556" data-mp="aqjikj1wkrfv" />
  }, {
    label: 'Email Campaigns',
    to: '/vendors/marketing/email-campaigns',
    icon: <MailIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2557" data-mp="139p313yuz0t3" />
  }, {
    label: 'Promo Graphics',
    to: '/vendors/marketing/promo-graphics',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2558" data-mp="2izziqu52rftg" />
  }, {
    label: 'Social Templates',
    to: '/vendors/marketing/social-templates',
    icon: <FileTextIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2559" data-mp="2xo4465vii5fx" />
  }, {
    label: 'Manage Events',
    to: '/manage-events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2560" data-mp="24zoqbmo49t66" />
  }]
}, {
  id: 'connections',
  label: 'Connections',
  icon: <HandshakeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2561" data-mp="202y8ouwnypin" />,
  children: [{
    label: 'Connection Hub',
    to: '/connections',
    icon: <HandshakeIcon className="h-5 w-5 mr-3 text-purple-500" data-id="element-2562" data-mp="29yrtt2og7rc1" />
  }, {
    label: 'Author Directory',
    to: '/authors/directory',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2563" data-mp="3qfnojt3uhpji" />
  }, {
    label: 'Connect with Authors',
    to: '/authors/connect',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2564" data-mp="1isud1xawvr85" />
  }, {
    label: 'Vendor Directory',
    to: '/vendors/directory',
    icon: <BuildingIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2565" data-mp="1nojd01qufa4z" />
  }, {
    label: 'Connect with Vendors',
    to: '/vendors/connect',
    icon: <StoreIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2566" data-mp="1xhh1coiintbi" />
  }, {
    label: 'Narrator Directory',
    to: '/narrators/directory',
    icon: <HeadphonesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2567" data-mp="26h3u6lx6jqsy" />
  }, {
    label: 'Connect with Narrators',
    to: '/narrators/connect',
    icon: <HeadphonesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2568" data-mp="2bh9roiq4s7iy" />
  }]
}, {
  id: 'bookstores',
  label: 'Bookstores',
  icon: <StoreIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2569" data-mp="h2yzq1e8ox8y" />,
  children: [{
    label: 'Bookstore Directory',
    to: '/bookstores',
    icon: <StoreIcon className="h-5 w-5 mr-3 text-purple-500" data-id="element-2570" data-mp="m1sedx59iuap" />
  }, {
    label: 'Manage Store Listings',
    to: '/vendors/store-listings',
    icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2571" data-mp="9q9iyyyrifon" />
  }, {
    label: 'Link Books to Stores',
    to: '/vendors/store-listings/link',
    icon: <LinkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2572" data-mp="3vyr95orixy9d" />
  }, {
    label: 'Stock & Availability',
    to: '/vendors/stock-availability',
    icon: <ShoppingBagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2573" data-mp="xg3sp7nsbo4o" />
  }, {
    label: 'Bookstore Partnerships',
    to: '/vendors/bookstore-partnerships',
    icon: <HandshakeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2574" data-mp="nhea1co2dznd" />
  }]
}, {
  id: 'services',
  label: 'Services',
  icon: <PencilIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2575" data-mp="ilyzatlcsjv6" />,
  children: [{
    label: 'All Service Providers',
    to: '/services/all',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-purple-500" data-id="element-2576" data-mp="33926z832vs66" />
  }, {
    label: 'Editing Services',
    to: '/services/editing',
    icon: <PencilIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2577" data-mp="1cfquno3n3deo" />
  }, {
    label: 'Connect with Editors',
    to: '/services/editing/connect',
    icon: <MailIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2578" data-mp="1r5y81pesi68i" />
  }, {
    label: 'Editor Gallery',
    to: '/services/editing/gallery',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2579" data-mp="204jye6qi6pju" />
  }, {
    label: 'Production Services',
    to: '/services/production',
    icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2580" data-mp="1w62ojffp70yq" />
  }, {
    label: 'Connect with Production',
    to: '/services/production/connect',
    icon: <MailIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2581" data-mp="254xvitqkgf33" />
  }, {
    label: 'Support Services',
    to: '/services/support',
    icon: <HelpCircleIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2582" data-mp="aqn4qfqevauo" />
  }, {
    label: 'Connect with Support',
    to: '/services/support/connect',
    icon: <MailIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2583" data-mp="2mftob6lkdj5z" />
  }, {
    label: 'Reader Services',
    to: '/services/readers',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2584" data-mp="2cop8k4o2dua3" />
  }]
}, {
  id: 'creative-arts',
  label: 'Creative Arts',
  icon: <PaletteIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2585" data-mp="2hl78mr8g94g3" />,
  children: [{
    label: 'Gallery Hub',
    to: '/gallery-hub',
    icon: <LayoutGridIcon className="h-5 w-5 mr-3 text-purple-500" data-id="element-2586" data-mp="28mlx3g1eapot" />
  }, {
    label: 'View All Creative Profiles',
    to: '/creative/all',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-purple-500" data-id="element-2587" data-mp="1trfpwpqkcktw" />
  }, {
    label: 'Cover Design',
    to: '/talent/designers',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2588" data-mp="3o45goylmxdx2" />
  }, {
    label: 'Cover Gallery',
    to: '/creative/cover-gallery',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2589" data-mp="3rl0bijxi8z0n" />
  }, {
    label: 'Interior Book Art',
    to: '/creative/interior-artists',
    icon: <LayoutDashboardIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2590" data-mp="3mkccpc31bdvv" />
  }, {
    label: 'Interior Art Gallery',
    to: '/creative/interior-art-gallery',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2591" data-mp="3dmaawubh8h7j" />
  }, {
    label: 'Character Art',
    to: '/creative/character-artists',
    icon: <BrushIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2592" data-mp="970wlxgkszjh" />
  }, {
    label: 'Character Art Gallery',
    to: '/creative/character-art-gallery',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2593" data-mp="4e7nyyhzl724" />
  }, {
    label: 'Book Merch & Branding',
    to: '/creative/merch-creators',
    icon: <ShoppingBagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2594" data-mp="wxmz797t9rm3" />
  }, {
    label: 'Merch Gallery',
    to: '/creative/merch-gallery',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2595" data-mp="2asms8prifoco" />
  }, {
    label: 'Photography',
    to: '/creative/photographers',
    icon: <CameraIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2596" data-mp="2fs9e1nlemcx3" />
  }, {
    label: 'Models',
    to: '/creative/models',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2597" data-mp="2osebp60spwy2" />
  }, {
    label: 'Photo Gallery',
    to: '/creative/photo-gallery',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2598" data-mp="2tqzcb6jymin1" />
  }, {
    label: 'Illustrators',
    to: '/creative/illustrators',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2599" data-mp="33hk8knc5vb2s" />
  }, {
    label: 'Digital Artists',
    to: '/creative/digital-artists',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2600" data-mp="37i41tftm5ujn" />
  }, {
    label: 'Painters',
    to: '/creative/painters',
    icon: <BrushIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2601" data-mp="3hgjx7uzobpyy" />
  }, {
    label: 'Graphic Designers',
    to: '/creative/graphic-designers',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2602" data-mp="33s9tsm67i5c4" />
  }, {
    label: 'Typographers',
    to: '/creative/typographers',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2603" data-mp="3dj4f9obmp0wi" />
  }, {
    label: '3D Artists',
    to: '/creative/3d-artists',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2604" data-mp="38nfczd8855wi" />
  }, {
    label: 'Submit Collaboration',
    to: '/talent/collaborate',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2605" data-mp="2fxp3xilg8u79" />
  }]
}, {
  id: 'events',
  label: 'Events',
  icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2606" data-mp="2urld1jpfhqvj" />,
  children: [{
    label: 'Events Hub',
    to: '/events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-purple-500" data-id="element-2607" data-mp="a2nwip9pigwt" />
  }, {
    label: 'Manage Events',
    to: '/manage-events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-purple-500" data-id="element-2608" data-mp="56glwj6d8h8j" />
  }, {
    label: 'Create Event',
    to: '/vendors/event-manager',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-purple-500" data-id="element-2609" data-mp="hnzr8p8f7kk9" />
  }, {
    label: 'Event Opportunities',
    to: '/vendors/events',
    icon: <ShoppingBagIcon className="h-5 w-5 mr-3 text-purple-500" data-id="element-2610" data-mp="7osh0awzg61d" />
  }, {
    label: 'Author Events',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2611" data-mp="vduxvgjsluut" />,
    children: [{
      label: 'Book Signings',
      to: '/events/book-signings',
      icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2612" data-mp="mmb2n4ed634l" />
    }, {
      label: 'Book Launches',
      to: '/events/book-launches',
      icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2613" data-mp="qljuu4tr9sy1" />
    }, {
      label: 'Author Talks',
      to: '/events/author-talks',
      icon: <MessageSquareIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2614" data-mp="1j4quqs33vg8x" />
    }, {
      label: 'Author Panels',
      to: '/events/author-panels',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2615" data-mp="1oy2o2qaa8vba" />
    }, {
      label: 'Multi-Author Signings',
      to: '/events/multi-author-signings',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2616" data-mp="1f0oenams16sh" />
    }]
  }, {
    label: 'Reader Community',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2617" data-mp="1a2d0wotd2c4z" />,
    children: [{
      label: 'Local Author Events',
      to: '/events/local-authors',
      icon: <MapPinIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2618" data-mp="1199rqspr0lg5" />
    }, {
      label: 'Reading Meetups',
      to: '/events/reading-meetups',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2619" data-mp="rau2ywe71o9t" />
    }, {
      label: 'Book Swaps',
      to: '/events/book-swaps',
      icon: <HeartHandshakeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2620" data-mp="c7khsxvkzmgx" />
    }]
  }, {
    label: 'Book Clubs',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2621" data-mp="h5c7dl8r6why" />,
    children: [{
      label: 'In-Person Book Clubs',
      to: '/events/book-clubs/in-person',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2622" data-mp="r3iag66aq8oe" />
    }, {
      label: 'Virtual Book Clubs',
      to: '/events/book-clubs/virtual',
      icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2623" data-mp="3ukqrint794i2" />
    }, {
      label: 'Silent Book Clubs',
      to: '/events/silent-book-clubs',
      icon: <BookmarkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2624" data-mp="85p938bbm6t4" />
    }]
  }, {
    label: 'Conferences & Festivals',
    icon: <BuildingIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2625" data-mp="36vpcghpv2v3t" />,
    children: [{
      label: 'Conventions & Festivals',
      to: '/events/conventions-festivals',
      icon: <BuildingIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2626" data-mp="twedh3pvwx2g" />
    }, {
      label: 'Reading Retreats',
      to: '/events/reading-retreats',
      icon: <CompassIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2627" data-mp="13v3m05vw5561" />
    }, {
      label: 'Midnight Releases',
      to: '/events/midnight-releases',
      icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2628" data-mp="1ctxebk26v9ds" />
    }]
  }, {
    label: 'Workshops & Learning',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2629" data-mp="18rarjxkdkeng" />,
    children: [{
      label: 'Writing Workshops',
      to: '/events/writing-workshops',
      icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2630" data-mp="1hns7rf7lj2q2" />
    }, {
      label: 'Publishing Workshops',
      to: '/events/publishing-workshops',
      icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2631" data-mp="1rlputzdpyth3" />
    }, {
      label: 'Craft Masterclasses',
      to: '/events/craft-masterclasses',
      icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2632" data-mp="2f5yx5elhfb07" />
    }]
  }, {
    label: 'Online Events',
    icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2633" data-mp="219v2xlalz2nq" />,
    children: [{
      label: 'Virtual Author Events',
      to: '/events/virtual-author-events',
      icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2634" data-mp="1rfusr50gz785" />
    }, {
      label: 'Livestream Discussions',
      to: '/events/livestream-discussions',
      icon: <MessageSquareIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2635" data-mp="1iewn6iadurng" />
    }, {
      label: 'Online Workshops',
      to: '/events/online-workshops',
      icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2636" data-mp="18jlh0od1isrb" />
    }]
  }, {
    label: 'Free Events',
    to: '/events/free',
    icon: <SparklesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2637" data-mp="1clhh0az20ivw" />
  }, {
    label: 'View All Events',
    to: '/events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2638" data-mp="1hjj0gx0e6k7w" />
  }]
}, {
  id: 'trove',
  label: 'Trove',
  icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2639" data-mp="17n65lvt420bk" />,
  children: [{
    label: 'All Articles & News',
    to: '/trove',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2640" data-mp="1vdsfztql7woq" />
  }, {
    label: 'Trove Updates',
    to: '/trove/updates',
    icon: <BellIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2641" data-mp="1lnqrx1y8ie9t" />
  }, {
    label: 'Services Hub',
    to: '/trove/services',
    icon: <PencilIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2642" data-mp="1qkpkhg292d5w" />
  }, {
    label: 'Awards & Recognition',
    to: '/trove/awards',
    icon: <TrophyIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2643" data-mp="2j34mgluj5qnc" />
  }, {
    label: 'Genre Spotlights',
    to: '/trove/genres',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2644" data-mp="7lrnct8o1bez" />
  }, {
    label: 'Audio & Narration',
    to: '/trove/audio',
    icon: <HeadphonesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2645" data-mp="hdxddxfcxirj" />
  }, {
    label: 'Industry Events',
    to: '/trove/events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2646" data-mp="cf49mwpvh64k" />
  }, {
    label: 'Author Launchpad',
    to: '/trove/author-launchpad',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2647" data-mp="3fvum9ufymhf8" />
  }]
}];